import buildSubjectApiPath from '@Application/Subjects/buildSubjectApiPath';
import type * as React from 'react';
import documentFieldConfirmationFailed, {
	type DocumentFieldConfirmationFailedAction,
} from '@Application/Beneficiaries/Documents/Actions/documentFieldConfirmationFailed';
import documentFieldConfirmed, {
	type DocumentFieldConfirmedAction,
} from '@Application/Beneficiaries/Documents/Actions/documentFieldConfirmed';
import type { DocumentDetailPayload } from '@Application/Beneficiaries/Documents/Actions/documentFetched';
import type ConfirmDocumentField from '@Application/Beneficiaries/Documents/Commands/ConfirmDocumentField';
import { post } from '@Domain/Api';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';

type Actions = DocumentFieldConfirmedAction | DocumentFieldConfirmationFailedAction;

export default (command: ConfirmDocumentField) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const payload = await post<DocumentDetailPayload>(
				`${buildSubjectApiPath(command.facilityId, command.subject)}/documents/${command.documentId}/fields/${encodeURIComponent(command.fieldKey)}/verifications`,
				{},
			);

			const action = documentFieldConfirmed(payload);
			dispatch(action);
			return action;
		} catch (error) {
			const action = documentFieldConfirmationFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
